import jplistCore from '../../js/jplist.core.min.js?raw';
import jplistPagination from '../../js/jplist.pagination-bundle.min.js?raw';
import {injectLegacyScripts} from '../shared/inject-legacy-script';
import {initFlexsliderBanner} from '../shared/flexslider-banner';
import {initPropertyList, installPropertyListPaginationGlobals} from '../shared/property-list';

injectLegacyScripts([
    jplistCore,
    jplistPagination,
]);

var $ = window.jQuery;

if ($) {
    $(document).ready(function () {
        var noResultsMessage = document.querySelector('[data-jplist-no-results-message]');

        if (noResultsMessage && !noResultsMessage.textContent.trim()) {
            noResultsMessage.textContent = 'No results found';
        }

        initPropertyList({
            storageName: 'jplist-collection-' + window.location.pathname.replace(/[^a-z0-9]+/gi, '-')
        });
        installPropertyListPaginationGlobals();
    });
}

initFlexsliderBanner('.flexslider');
